<div class="blank-layout-container justify-content-center">
  <div class="row">
    <div class="not-found-wrapper">
      <img src="../../../../assets/images/page-not-found.png" alt="error-bg">
      <button type="button" (click)="routeToHome()" class="back-button" mat-flat-button color="accent"
        matBadgePosition="after" matBadgeColor="accent" MatBadgeSize="large" style="margin-left: 14px">
        <p class="btn-text">
          Back to Home
        </p>
      </button>
    </div>
  </div>
</div>